var map = {
	"app/pages/account/account.module": [
		"./src/app/pages/account/account.module.ts",
		"app-pages-account-account-module"
	],
	"app/pages/articles/article.module": [
		"./src/app/pages/articles/article.module.ts",
		"app-pages-articles-article-module"
	],
	"app/pages/dashboard/dashboard.module": [
		"./src/app/pages/dashboard/dashboard.module.ts",
		"app-pages-dashboard-dashboard-module"
	],
	"app/pages/forgot-password/forgot-password.module": [
		"./src/app/pages/forgot-password/forgot-password.module.ts",
		"app-pages-forgot-password-forgot-password-module"
	],
	"app/pages/genres/genre.module": [
		"./src/app/pages/genres/genre.module.ts",
		"app-pages-genres-genre-module"
	],
	"app/pages/login/login.module": [
		"./src/app/pages/login/login.module.ts",
		"app-pages-login-login-module"
	],
	"app/pages/musics/music.module": [
		"./src/app/pages/musics/music.module.ts",
		"app-pages-musics-music-module"
	],
	"app/pages/settings/setting.module": [
		"./src/app/pages/settings/setting.module.ts",
		"app-pages-settings-setting-module"
	],
	"app/pages/users/user.module": [
		"./src/app/pages/users/user.module.ts",
		"app-pages-users-user-module"
	],
	"app/pages/venues/venue.module": [
		"./src/app/pages/venues/venue.module.ts",
		"app-pages-venues-venue-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return __webpack_require__.e(ids[1]).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;